module.exports = __webpack_public_path__ + "posture/static/img/leg_xo.e41a82a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/leg_xo.png
// module id = Oy1c
// module chunks = 1